export default __webpack_public_path__ + "static/media/worldclassamenities.e0a6ccd5.jpg";